import { POST, PUT } from "config/constants/adapter_constants";
import { getTenantFromToken } from "config/helpers/common_helper";
import i18n from "multilingual";
import { toast } from "react-toastify";
import { hideLoader, showLoader } from "redux/actions/loaderActions";
import { store } from "redux/store";
import { auditPayload } from "./audithelpers";
import HTTPRequest, {
  FHIRDelete,
  FHIRSave,
  FHIRSearch,
  HTTPAidaBaseService,
  HTTPMetadata,
} from "./http";
import { isEmpty } from "lodash";

const data = store.getState();

export const GET_PATIENT = async (activePersonId) => {
  try {
    let res = await FHIRSearch(`Patient/${activePersonId}`);
    if (res?.data?.total > 0) {
      return res.data.entry[0];
    } else {
      toast.info(i18n.t("common.PATIENT_DATA_NOT_FOUND"));
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_ENCOUNTER_BY_ID = async (encounterId) => {
  try {
    let res = await FHIRSearch(`Encounter/${encounterId}`);
    if (res?.data?.total) {
      return res?.data?.entry[0];
    }
  } catch (e) {
    console.log(e);
  }
};

export const UPDATE_PATIENT = async (payload) => {
  try {
    let response = await FHIRSave(PUT, payload);
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR_UPDATING_PATIENT"));
  }
};

export const GET_SOCIAL_HISTORY = async (activePersonId) => {
  try {
    let res = await FHIRSearch(
      ``,
      `resourceType=Observation&subject=${activePersonId}&category=social-history`
    );
    if (res?.data?.total > 0) {
      return res.data.entry[0];
    } else {
      // toast.info('Patient data not found')
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_RATING_SCALE_LIST = async (activePersonId, params = "") => {
  try {
    let res = await FHIRSearch(
      ``,
      `resourceType=QuestionnaireResponse&subject=${activePersonId}${params}`
    );
    if (res?.data?.total > 0) {
      return res.data;
    } else {
      return {};
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_DIAGNOSIS_DETAILS = async (
  activePersonId,
  params = "",
  clinicalStatus = "active,recurrence,relapse"
) => {
  try {
    let response6 = await FHIRSearch(
      ``,
      `resourceType=Condition&code:not=46239-0&code:not=10164-2&subject=${activePersonId}${params}&clinical-status=${clinicalStatus}`
    );
    if (response6?.data?.total > 0) {
      return response6?.data;
    }
  } catch (e) {
    console.error(`error:${e}`);
  }
};

export const GET_CARE_PLAN_DETAILS = async (
  activePersonId,
  params = "",
  status = ""
) => {
  try {
    let url = `resourceType=CarePlan&patient=${activePersonId}${params}`;
    if (status) {
      url += `&status=${status}`;
    }
    let response = await FHIRSearch(``, url);
    if (response?.data?.total > 0) {
      return response?.data;
    }
  } catch (e) {
    console.error(`error:${e}`);
  }
};

export const GET_GOAL_DETAILS = async (goalIds, params = "") => {
  try {
    let url = `_id=${goalIds}${params}`;

    let response = await FHIRSearch(`Goal`, url);
    if (response?.data?.total > 0) {
      return response?.data;
    }
  } catch (e) {
    console.error(`error:${e}`);
  }
};

export const GET_VITAL = async (activePersonId) => {
  try {
    // let res = await FHIRSearch(``, `resourceType=Observation&subject=${activePersonId}&category=vital-signs`)
    let res = await FHIRSearch(
      ``,
      `resourceType=Observation&subject=${activePersonId}`
    );
    if (res?.data?.total > 0) {
      // const weight = res?.data?.entry?.filter(f => f?.resource?.code?.coding?.[0]?.display === 'Weight')?.[0]?.resource?.valueQuantity;
      // const height = res?.data?.entry?.filter(f => f?.resource?.code?.coding?.[0]?.display === 'Height')?.[0]?.resource?.valueQuantity;
      // const pulse = res?.data?.entry?.filter(f => f?.resource?.code?.coding?.[0]?.display === 'Pulse')?.[0]?.resource?.valueQuantity;
      // return {
      //     weight,
      //     height,
      //     pulse,
      // }
      return res?.data?.entry;
    } else {
      return {};
      // toast.info('Patient vital data not found')
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_VITAL_SORT = async (activePersonId, startDate, endDate) => {
  try {
    let query = `resourceType=Observation&subject=${activePersonId}&category=vital-signs`;
    if (startDate) {
      query += `&date=ge${startDate}`;
    }
    if (endDate) {
      query += `&date=le${endDate}`;
    }
    let res = await FHIRSearch(``, query);
    if (res?.data?.total > 0) {
      // You can further process the data here, such as filtering specific vital signs
      return res?.data?.entry;
    } else {
      return {};
      // Optionally, you can display a message if no data is found
      // toast.info('Patient vital data not found')
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_VITAL = async (payload) => {
  try {
    let res = await FHIRSave("executeBundle", payload);
    if (res?.data) {
      toast.success(i18n.t("common.VITALS_ADDED_SUCCESSFULLY"));
      return res;
    }
  } catch (e) {
    toast.error(i18n.t("common.ERROR_CREATING_VITALS"));
  }
};

export const GET_UPCOMING_APPOINTMENTS = async (activePersonId) => {
  try {
    let res = await FHIRSearch(
      `Appointment`,
      `patient=${activePersonId}&status=booked,proposed`
    );
    if (res?.data?.total > 0) {
      return res.data;
    } else {
      // toast.info('Patient data not found')
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_LOCATIONS = async () => {
  try {
    let filterToRemoveVirtualLocation = `type:not=http://enliv.com/location/type|enliv-internal-virtual-location`;
    let res = await FHIRSearch(`Location?${filterToRemoveVirtualLocation}`);
    if (res?.data?.total > 0) {
      return res;
    } else {
      toast.info(i18n.t("common.LOCATIONS_NOT_FOUND"));
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_LOCATION_BY_ID = async (id) => {
  try {
    let res = await FHIRSearch(`Location/${id}`);
    if (res?.data?.total > 0) {
      return res?.data?.entry?.[0];
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_DOC_WITH_LOC = async (id) => {
  try {
    let res = await FHIRSearch(`?resourceType=PractitionerRole&location=${id}`);
    if (res?.data?.total > 0) {
      return res;
    } else {
      toast.info(i18n.t("common.PRACTITIONER_WITH_LOCATIONS_NOT_FOUND"));
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_PRACTITIONER = async () => {
  try {
    let res = await FHIRSearch(`Practitioner`);
    if (res?.data?.total > 0) {
      return res;
    } else {
      toast.info(i18n.t("common.PRACTITIONER_NOT_FOUND"));
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_RATING_SCALE = async (method, payload) => {
  try {
    let res = await FHIRSave(method, payload);
    return res;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_PRACTITIONER = async (payload) => {
  try {
    let res = await FHIRSave(POST, payload);
    return res;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const SAVE_USER_SETTINGS = async (method, payload) => {
  try {
    let res = await FHIRSave(method, payload);
    return res;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_USER_SETTINGS = async (personId) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Basic&code=user.preference.ui&subject=Person/${personId}`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_BASIC_RESOURCE = async ({ resourceName, personId }) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Basic&code=${resourceName}&subject=Person/${personId}`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_VOICE_EDIT_SETTINGS = async (personId) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Basic&code=user.voiceEdit.time&subject=Person/${personId}`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const SAVE_VOICE_EDIT_SETTINGS = async (method, payload) => {
  try {
    let res = await FHIRSave(method, payload);
    return res;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_USER_PRACITCE_DATA = async (personId) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Basic&code=user.preference.practice&subject=Person/${personId}`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const SAVE_TEMPLATE_PREFERENCES = async (method, payload) => {
  try {
    let res = await FHIRSave(method, payload);
    return res;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_TEMPLATE_PREFERENCES = async (personId) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Basic&code=user.template.preferences&subject=Person/${personId}`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const SAVE_DEFAULT_TEMPLATE_PREFERENCES = async (method, payload) => {
  try {
    let res = await FHIRSave(method, payload);
    return res;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_DEFAULT_TEMPLATE_PREFERENCES = async (personId) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Basic&code=user.default.template&subject=Person/${personId}`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const IS_TELEHEALTH_ENABLED = async (providerId) => {
  try {
    const type = `http://enliv.com/location/type|enliv-internal-virtual-location`;
    const identifier = `http://enliv.com/telehealth/zoom/asscociated-practitioner-id|${providerId}`;

    let url = `?resourceType=Location&type=${type}&identifier=${identifier}`;
    let response = await FHIRSearch(url);
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_APPOINTMENTS_FROM_PRACTITIONER_LOCATION = async (
  locationId,
  practitionerId
) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Appointment&practitioner=${practitionerId}&location=${locationId}`
    );
    let eventData = [];
    let data = response?.data?.entry;

    for (let i = 0; i < data?.length; i++) {
      let item = data[i];
      let allParticipants = item?.resource?.participant;
      let patientObjectNew = allParticipants?.find((x) =>
        x?.actor?.reference?.includes("Patient")
      );
      let patName = patientObjectNew?.actor?.display;
      //   let st = formatTimeTo12Hour(item.resource.start);
      //   let et = formatTimeTo12Hour(item.resource.end);
      let title = `${patName} - ${item?.resource?.start} to ${item?.resource?.start} - ${item?.resource?.status}`;

      const isTelehealth = item?.resource?.serviceType?.some(
        (item) => item?.coding?.[0]?.code === "telehealth"
      );

      eventData.push({
        id: item?.resource?.id,
        title: title,
        start: item?.resource?.start,
        end: item?.resource?.end,
        status: item?.resource?.status,
        raw: item,
        isTelehealth: isTelehealth,
      });
    }
    return eventData;
  } catch (e) {
    toast.error(i18n.t("common.ERROR_FETCHING_APPOINTMENTS"));
  } finally {
  }
};

export const GET_VISITS = async (patientId) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Composition&subject=${patientId}&_sort=-date&status=preliminary,amended,final`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const DELETE_VISIT = async (compositionId) => {
  try {
    let response = await FHIRDelete("Composition", compositionId);
    return response;
  } catch (error) {
    console.log(error.message);
  }
};

export const GET_VISITS_BY_KEYWORD = async ({ patientId, searchKeyword }) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Composition&subject=${patientId}&title:contains=${searchKeyword}&status=preliminary,amended,final`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_ENCOUNTER = async (payload) => {
  try {
    let response = await FHIRSave(POST, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_TASK = async (payload) => {
  try {
    let response = await FHIRSave(POST, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_TASK_BY_ID = async (taskId) => {
  try {
    let res = await FHIRSearch(`Task/${taskId}`);
    if (res?.data?.total > 0) {
      return res.data.entry[0];
    } else {
      toast.info("Task not found");
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const UPDATE_COMPOSITION = async (payload) => {
  try {
    let response = await FHIRSave(PUT, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const UPDATE_ENCOUNTER = async (payload) => {
  try {
    let response = await FHIRSave(PUT, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_OBSERVATION = async (payload) => {
  try {
    let response = await FHIRSave(POST, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_COMPOSITION = async (payload) => {
  try {
    let response = await FHIRSave(POST, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const CREATE_PATIENT = async (payload) => {
  try {
    let response = await FHIRSave(POST, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const UPDATE_CLINICAL_IMPRESSION = async (payload) => {
  try {
    let response = await FHIRSave(PUT, payload);
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_COMPOSITION = async (encounterId, { patientId = "" } = {}) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Composition&encounter=${encounterId}&status=preliminary,amended,final`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_ALL_COMPOSITION = async (
  status,
  {
    organizationId = "",
    searchQuery = "",
    practitionerId = "",
    params = "",
  } = {}
) => {
  try {
    let query =
      status !== "all"
        ? `?resourceType=Composition&status=${status}`
        : `?resourceType=Composition&status=preliminary,amended,final`;

    if (practitionerId) {
      query += `&author=Practitioner/${practitionerId}`;
    } else if (organizationId) {
      query += `&author=Organization/${organizationId}`;
    }

    query += searchQuery ? `&title:contains=${searchQuery}` : "";

    if (params) {
      query += params;
    }

    if (practitionerId || organizationId) {
      let response = await FHIRSearch(query);
      return response;
    }
    return false;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_CLINICAL_IMPRESSION_BY_KEYWORD = async ({
  patientId,
  searchKeyword,
}) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Observation&subject=${patientId}&code=gen-clinical-notes&value-string:contains=${searchKeyword}`
    );
    return response;
  } catch (err) {
    console.error(err);
    toast.error(
      err?.response?.data?.issue?.[0]?.diagnostics || "Error While Searching"
    );
  }
};

export const GET_CLINICAL_IMPRESSION = async (
  encounterId,
  { patientId = "" } = {}
) => {
  try {
    let response = await FHIRSearch(
      `?resourceType=Observation&encounter=${encounterId}&_sort=date`
    );
    return response;
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_OBSERVATON_BY_ID = async (id) => {
  try {
    let response = await FHIRSearch(`/Observation/${id}`);
    return response?.data?.entry?.[0];
  } catch (err) {
    console.log("e");
  }
};

export const GET_TASKS = async (
  activePersonId,
  params = "",
  status = "requested,accepted,completed,rejected,on-hold,in-progress"
) => {
  try {
    const response = await FHIRSearch(
      `Task?patient=${activePersonId}${params}&status=${status}`
    );

    if (response?.data?.total) {
      return response?.data;
    }
  } catch (e) {
    toast.error(i18n.t("tasks.ERROR_FETCHING_TASKS"));
  }
};

export const GET_PRACTITIONER_UNIQUE_TASKS = async (
  practitionerId,
  encounterId
) => {
  try {
    const response = await FHIRSearch(
      `Task?owner=Practitioner/${practitionerId}&focus=Encounter/${encounterId}`
    );
    if (response?.data?.total) {
      return response?.data;
    }
  } catch (e) {
    console.error("error: ", e);
  }
};

export const GET_ALL_TASKS_PRACTITIONER = async (
  practitionerId,
  code,
  params = ""
) => {
  try {
    const response = await FHIRSearch(
      `Task?owner=Practitioner/${practitionerId}&code=http://enliv.com/code/task-type|${code}&_sort=-_lastUpdated&_count=100${params}`
    );
    if (response?.data?.total) {
      return response?.data;
    }
  } catch (e) {
    console.error("error: ", e);
  }
};

export const GET_PATIENT_LIST = async (
  activePersonId,
  params = "",
  reduxDispatch = () => {}
  // status = 'requested,accepted,completed,rejected,on-hold,in-progress'
) => {
  // const dispatch = useDispatch();
  reduxDispatch(showLoader());
  try {
    const response = await FHIRSearch(`Patient?${params}`);
    reduxDispatch(hideLoader());
    if (response?.data?.total) {
      return response?.data;
    }
  } catch (e) {
    reduxDispatch(hideLoader());
    toast.error(i18n.t("tasks.PATIENT_DATA_NOT_FOUND"));
  }
};

export const GET_TATIENT_BY_ID = async (personId) => {
  try {
    const response = await FHIRSearch(`Patient/${personId}`);
    if (response?.data?.total) {
      return response?.data;
    }
  } catch (e) {
    toast.error(i18n.t("tasks.ERROR_FETCHING_TASKS"));
  }
};

export const GET_SINGLE_TASK_DETAIL = async (taskId) => {
  try {
    const response = await FHIRSearch(`Task/${taskId}`);
    return response;
  } catch (e) {
    toast.error(i18n.t("tasks.ERROR_FETCHING_TASKS"));
  }
};

export const UPDATE_TASK = async (payload) => {
  try {
    const data = {
      resourceType: "Bundle",
      type: "batch",
      entry: [
        {
          resource: payload,
          request: {
            method: "PUT",
            url: `Task/${payload?.id}`,
          },
        },
      ],
    };
    let res = await FHIRSave("executeBundle", data);
    if (res?.data) {
      return res;
    }
  } catch (e) {
    toast.error(i18n.t("tasks.TASK_UPDATE_FAILED"));
  }
};

export const CREATE_DYNAMIC_FORM = async ({
  userId = ``,
  formKey = ``,
} = {}) => {
  let response = await HTTPMetadata("post", "forms/formData/create", "", {
    object: {
      slFormKey: formKey,
    },
  });

  if (!response?.data?.insert_Production_SLFormData_one?.id)
    throw new Error(`Form Id not generated`);

  let assignUserParams = {
    sl_form_data_id: "",
    user_id: "",
    user_type: "",
  };
  assignUserParams.sl_form_data_id =
    response?.data?.insert_Production_SLFormData_one?.id;
  assignUserParams.user_id = userId;
  assignUserParams.user_type = "Patient";

  response = await HTTPMetadata(
    "post",
    "forms/formData/assignUser",
    "",
    assignUserParams
  );

  if (!response?.data?.insert_Production_user_forms_one?.sl_form_data_id)
    throw new Error(`User Form Id not generated`);

  const formId = formKey;
  const formDataId =
    response?.data?.insert_Production_user_forms_one?.sl_form_data_id;

  return { formId, formDataId };
};

export const GET_RELATED_PERSONS = async (links) => {
  let patientObj =
    links?.find((f) => f?.target?.reference?.includes("Patient")) ||
    "No Patient Id found";
  let patientData = {};
  if (patientObj != "No Patient Id found") {
    let res = await FHIRSearch(
      `Patient/${patientObj?.target?.reference?.split("/")?.[1]}`
    );
    patientData.relatedPersonName =
      res?.data?.entry?.[0]?.resource?.name?.[0]?.text;
    patientData.patientId = res?.data?.entry?.[0]?.resource?.id;
    patientData.relation = "self";
    patientData.disabled = !res?.data?.entry?.[0]?.resource?.active;
  }

  const relatedPersonIds = (links || [])
    .filter((data) => {
      return data?.target?.reference?.includes("RelatedPerson");
    })
    .map((data) => {
      return data?.target?.reference?.split("/")?.[1];
    });

  if (relatedPersonIds?.length > 0) {
    try {
      const personUrl = `_id=${relatedPersonIds?.join(",")}`;
      const personResponse = await FHIRSearch("RelatedPerson", personUrl);
      const relatedPersons = personResponse?.data?.entry?.map((o) => {
        return {
          patientId: o?.resource?.patient?.reference?.split("/")?.[1],
          relatedPersonName: o?.resource?.patient?.display,
          relation: o?.resource?.relationship?.[0]?.coding?.[0]?.display,
          disabled: !o?.resource?.active,
        };
      });
      // let relatedPerson_patientIds=relatedPersons?.map(id=>id?.patientId)?.join(',')
      // let relatedPerson_patient_data=await FHIRSearch(`Patient/${relatedPerson_patientIds}`)

      if (patientObj != "No Patient Id found") {
        return [...relatedPersons, patientData];
      } else {
        return relatedPersons;
      }
    } catch (e) {
      console.log("error---", e?.message);
    }
  } else {
    return [patientData];
  }
};

export const SCHEDULE_APPOINTMENT = async (payload) => {
  try {
    let response;
    if (payload?.id) {
      response = await FHIRSave(PUT, payload);
    } else {
      response = await FHIRSave(POST, payload);
    }
    return response;
  } catch (e) {
    toast.error(i18n.t("common.ERROR_SCHEDULING_APPOINTMENTS"));
  }
};

export const GET_APPOINTMENT_BY_ID = async (appointmentId) => {
  try {
    let res = await FHIRSearch(`Appointment/${appointmentId}`);
    if (res?.data?.total > 0) {
      return res.data.entry[0];
    } else {
      toast.info(i18n.t("common.APPOINTMENT_DATA_NOT_FOUND"));
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

export const GET_ACTIVE_MEDICATIONS = async (activePersonId) => {
  try {
    const response = await HTTPRequest.get(
      `metadata/v1/download/getPatientMedication?patientId=${activePersonId}`
    );
    return response?.data?.activeMedications;
  } catch (e) {
    console.error("error:", e);
  }
};

export const GET_PROMPT_LIST = async () => {
  try {
    const response = await HTTPRequest.get(
      `/ai-copilot/v1/${getTenantFromToken()}/prompt/list`
    );
    return response?.data;
  } catch (error) {
    console.error(error.message);
  }
};

export const GET_ICD_CPT_CODES = async (payload) => {
  try {
    let response = await HTTPAidaBaseService.post(
      `/${getTenantFromToken()}/generate-codes`,
      {
        ...payload,
      }
    );
    // if (!response?.data?.cpt_codes?.length) {
    //   response.data.cpt_codes[0] = { "cpt-code": "Not Mentioned" };
    // }
    // if (!response?.data?.icd_codes?.length) {
    //   response.data.icd_codes[0] = { "icd-10-code": "Not Mentioned" };
    // }
    return response;
  } catch (error) {
    console.error(error.message);
    return error;
  }
};

export const EXECUTE_PROMPT = async ({
  prompt_code = "",
  language = "English",
  transcript = "",
  previous_soap_note = "",
  patient = {},
  patient_details = {},
  soap_note = "",
  practitioner = {},
  currentDate = "",
  signal,
  requireLanguageAndConversation = true,
  source_language,
  target_language,
}) => {
  let payload = {
    // prompt_code: prompt_code,
    params: {
      // language: language,
      // conversation: transcript,
      // patient: {...patient},
      // practitioner: {...practitioner},
    },
  };
  if (requireLanguageAndConversation) {
    payload.params = {
      language: language,
      conversation: transcript,
    };
  }
  if (source_language) {
    payload.params.source_language = source_language;
  }
  if (target_language) {
    payload.params.target_language = target_language;
  }
  if (!isEmpty(patient)) {
    payload.params.patient = { ...patient };
  }
  if (!isEmpty(patient_details)) {
    payload.params.patient_details = { ...patient_details };
  }
  if (!isEmpty(practitioner)) {
    payload.params["referring_doctor"] = { ...practitioner };
  }
  if (!isEmpty(currentDate) && currentDate.length > 0) {
    payload.params["current_date"] = currentDate;
  }

  if (previous_soap_note) {
    payload.params.previous_soap_note = previous_soap_note;
  }
  if (soap_note) {
    payload.params.soap_note = soap_note;
  }
  try {
    const response = await HTTPAidaBaseService.post(
      `/${getTenantFromToken()}/submit/${prompt_code}`,
      payload,
      { signal: signal }
    );

    return response;
  } catch (error) {
    toast.error(error?.response?.data?.message || error?.message);
    console.error(error.message);
    return false;
  }
};

export const GET_PLANS_LIST = async () => {
  try {
    const response = await HTTPAidaBaseService.get(`/billing/plan-prices`);

    return response.data;
  } catch (error) {
    toast.error(error?.message);
    console.error(error.message);
    return false;
  }
};

export const GET_CUSTOMER_SUBSCRIPTION = async () => {
  try {
    const response = await HTTPAidaBaseService.post(
      `/billing/${getTenantFromToken()}/subscriptions/search`
    );

    return response.data;
  } catch (error) {
    toast.error(error?.message);
    console.error(error.message);
    return false;
  }
};

export const EXECUTE_PROMPT_GENERIC = async (prompt_code, promptParams) => {
  try {
    let payload = {
      // prompt_code: prompt_code,
      params: promptParams,
    };
    const response = await HTTPAidaBaseService.post(
      `/${getTenantFromToken()}/submit/${prompt_code}`,
      payload
    );

    return response.data;
  } catch (error) {
    toast.error(error?.message);
    console.error(error.message);
    return false;
  }
};

export const GET_ALLERGIES = async (activePersonId) => {
  try {
    let res = await FHIRSearch(
      ``,
      `resourceType=AllergyIntolerance&patient=${activePersonId}`
    );

    if (res?.data?.total > 0) {
      return res;
    } else {
      // toast.info(i18n.t('allergies.ALLERGIES_DATA_NOT_FOUND'))
    }
  } catch (err) {
    toast.error(i18n.t("common.ERROR"));
  }
};

// export const singleFileDownloadUrlGeneratorFromFhirUrl = ({
//   type = "thumbnail",
//   fileNameUrl,
// } = {}) => {
//   if (!fileNameUrl) return;
//   const spArr = fileNameUrl?.split(".");
//   if (type === "thumbnail") {
//     // debugger;
//     spArr?.splice(1, 0, "160x160_thumbnail");
//     fileNameUrl = spArr?.join(".");
//   }

//   let url = `/file/getSingleFileDownloadUrl/?fileName=${fileNameUrl}#${Date.now()}`;
//   const token = localStorage.getItem(`jwtToken`);
//   if (token) {
//     const jwtPayload = jwtDecode(token);
//     let tenantId = jwtPayload?.firebase?.tenant; //'Enliv-Dev-cr017';
//     url = `/file/${tenantId}/getSingleFileDownloadUrl/?fileName=${fileNameUrl}#${Date.now()}`;
//   }

//   let baseUrl = process.env.REACT_APP_API_URL + url;
//   // debugger;
//   return baseUrl;
// };

export const CREATE_AUDIT_EVENT = async (props) => {
  const payload = auditPayload(
    props?.practitionerID,
    props?.patientName,
    props?.type,
    props?.reason
  );
  try {
    let res = await FHIRSave(POST, payload);
    if (res?.data) {
      return res;
    }
  } catch (e) {
    console.log(e);
  }
};

export const GET_AUDIT_EVENTS = async (params = "") => {
  try {
    let res = await FHIRSearch(`/AuditEvent?_sort=-date${params}`);
    if (res?.data) {
      return res;
    }
  } catch (e) {
    console.log(e);
  }
};
